import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BulkDownloadStatus, QueryTranslationRequestBulkDownloadStatusArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryTranslationRequestBulkDownloadStatusArgs;
type TData = BulkDownloadStatus;

const MOCK: TVariables = {
  guid: ''
};

export const useTranslationRequestBulkDownloadStatus = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query translationRequestBulkDownloadStatus($guid: String!) {
      translationRequestBulkDownloadStatus(guid: $guid) {
        status
        file
        progress
        completedTranslationRequests
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useTranslationRequestBulkDownloadStatus', variables.guid],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
